import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { ACCESS_RIGHTS_RESOURCE } from './accessRightsService';
import { VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/vehicleAccessRightsService';
import { getErrorCodeConvertor } from '../../app/lib/errorCodeConvertor';
import { ON_PREMISE_ACCESS_RIGHTS_RESOURCE } from '../constants';
import { OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/offPremiseVehicleAccessRightsService';
import { ON_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/onPremiseVehicleAccessRightsService';
import { OFF_PREMISE_ACCESS_RIGHTS_RESOURCE } from '../../requests/services/offPremiseAccessRightsService';
import apiRoutes from '../../../app/api/routes';
import { PRIVATE_VEHICLES_RESOURCE } from '../../vehicles/constants';

export default ComposedComponent =>
  compose(
    withTranslation(),
    reduxFetch(props => [
      {
        resource: 'createAccessRight',
        method: 'post',
        request: (body, redirectRoute) => ({
          body,
          url: apiRoutes.createAccessRight(),
          meta: {
            toaster: {
              onSuccessMessage: props.t('accessRightCreateSuccess'),
              onErrorMessage: getErrorCodeConvertor(props.t, 'accessRightCreateErr'),
            },
            redirectRoute,
            updateOtherLists: [
              {
                resource: PRIVATE_VEHICLES_RESOURCE,
                listPath: 'values',
                idProp: 'id',
                id: body.vehicleId,
                values: {
                  hasActiveAccessRights: true,
                },
              },
            ],
            addToOtherLists: [
              {
                listPath: 'values',
                resource: ON_PREMISE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: VEHICLE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: ON_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: OFF_PREMISE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: ACCESS_RIGHTS_RESOURCE,
              },
            ],
          },
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
